import { CheckboxListItem } from '../components/checkbox-list/model/checkbox-list-item.model';


export const LETTER_A: CheckboxListItem[] = [
  {label: 'Academia de ginástica', value: 'academia'},
  {label: 'Acesso à internet', value: 'Acesso à internet'},
  {label: 'Acesso para deficientes físicos', value: 'Acesso para deficientes físicos'},
  {label: 'Adega / champagnerie', value: 'Adega / champagnerie'},
  {label: 'Antena parabólica', value: 'Antena parabólica'},
  {label: 'Aquecedor central', value: 'Aquecedor central'},
  {label: 'Ar-condicionado', value: 'Ar-condicionado'},
  {label: 'Arborismo', value: 'Arborismo'},
  {label: 'Arborização de ruas', value: 'Arborização de ruas'},
  {label: 'Área de lazer', value: 'Área de lazer'},
  {label: 'Área verde', value: 'Área verde		'},
  {label: 'Armário embutido', value: 'Armário embutido'},
  {label: 'Arvorismo', value: 'Arvorismo'},
  {label: 'Ateliê', value: 'Ateliê'},
  {label: 'Auditório', value: 'Auditório'},
];

export const LETTER_B: CheckboxListItem[] = [
  {label: 'Banheira/hidromassagem', value: 'Banheira/hidromassagem'},
  {label: 'Bar', value: 'Bar'},
  {label: 'Bicicletário', value: 'Bicicletário'},
  {label: 'Biribol', value: 'Biribol'},
  {label: 'Bocha', value: 'Bocha'},
  {label: 'Brinquedoteca', value: 'Brinquedoteca'},
];

export const LETTER_C: CheckboxListItem[] = [
  {label: 'Cafeteria', value: 'Cafeteria'},
  {label: 'Calçada gramada', value: 'Calçada gramada'},
  {label: 'Campo de futebol', value: 'Campo de futebol'},
  {label: 'Campo de golf', value: 'Campo de golf'},
  {label: 'Car wash', value: 'Car wash'},
  {label: 'Casa da árvore', value: 'Casa da árvore'},
  {label: 'Centro comercial', value: 'Centro comercial'},
  {label: 'Centro de conveniência', value: 'Centro de conveniência'},
  {label: 'Chafariz', value: 'Chafariz'},
  {label: 'Child care', value: 'Child care'},
  {label: 'Chimarródromo', value: 'Chimarródromo'},
  {label: 'Churrasqueira', value: 'Churrasqueira'},
  {label: 'Ciclovia', value: 'Ciclovia'},
  {label: 'Cinema', value: 'Cinema'},
  {label: 'Closet', value: 'Closet'},
  {label: 'Clube', value: 'Clube'},
  {label: 'Concierge', value: 'Concierge'},
  {label: 'Copa', value: 'Copa'},
  {label: 'Cozinha americana', value: 'Cozinha americana'},
  {label: 'Cozinha mobiliada', value: 'Cozinha mobiliada'},
];

export const LETTER_D: CheckboxListItem[] = [
  {label: 'Deck', value: 'Deck'},
  {label: 'Dependência de empregados', value: 'Dependência de empregados'},
  {label: 'Depósito', value: 'Depósito'},
  {label: 'Despensa', value: 'Despensa'},
  {label: 'Detector de incêndio', value: 'Detector de incêndio'},
  {label: 'Duplex', value: 'Duplex'},
];

export const LETTER_E: CheckboxListItem[] = [
  {label: 'Elevador', value: 'Elevador'},
  {label: 'Escada rolante', value: 'Escada rolante'},
  {label: 'Espaço gourmet', value: 'Espaço gourmet'},
  {label: 'Espaço zen', value: 'Espaço zen'},
  {label: 'Estacionamento rotativo', value: 'Estacionamento rotativo'},
];

export const LETTER_F: CheckboxListItem[] = [
  {label: 'Fibra ótica', value: 'Fibra ótica'},
  {label: 'Fitness', value: 'Fitness'},
  {label: 'Forno para pizza', value: 'Forno para pizza'},
  {label: 'Forro rebaixado', value: 'Forro rebaixado'},
  {label: 'Frente para o mar', value: 'Frente para o mar'},
];

export const LETTER_G: CheckboxListItem[] = [
  {label: 'Garage band', value: 'Garage band'},
  {label: 'Garage band / danceteria', value: 'Garage band / danceteria'},
  {label: 'Garagem', value: 'Garagem'},
  {label: 'Gazebo', value: 'Gazebo'},
  {label: 'Gerador', value: 'Gerador'},
];

export const LETTER_H: CheckboxListItem[] = [
  {label: 'Hall', value: 'Hall'},
  {label: 'Heliponto', value: 'Heliponto'},
  {label: 'Home office', value: 'Home office'},
  {label: 'Horta', value: 'Horta'},
  {label: 'Horta comunitária', value: 'Horta comunitária'},
];

export const LETTER_L: CheckboxListItem[] = [
  {label: 'Lago', value: 'Lago'},
  {label: 'Lan house', value: 'Lan house'},
  {label: 'Lareira', value: 'Lareira'},
  {label: 'Lavanderia', value: 'Lavanderia'},
  {label: 'Living', value: 'Living'},
  {label: 'Lounge', value: 'Lounge'},
];

export const LETTER_M: CheckboxListItem[] = [
  {label: 'Massagem', value: 'Massagem'}
];

export const LETTER_O: CheckboxListItem[] = [
  {label: 'Ofurô', value: 'Ofurô'},
  {label: 'Orquidário', value: 'Orquidário'},
];

export const LETTER_P: CheckboxListItem[] = [
  {label: 'Parede de escalada', value: 'Parede de escalada'},
  {label: 'Pay-per-use', value: 'Pay-per-use'},
  {label: 'Pérgola', value: 'Pérgola'},
  {label: 'Pet care', value: 'Pet care'},
  {label: 'Piscina', value: 'Piscina'},
  {label: 'Piscina adulto coberta', value: 'Piscina adulto coberta'},
  {label: 'Piscina adulto descoberta', value: 'Piscina adulto descoberta'},
  {label: 'Piscina coberta', value: 'Piscina coberta'},
  {label: 'Piscina com raia', value: 'Piscina com raia'},
  {label: 'Piscina descoberta', value: 'Piscina descoberta'},
  {label: 'Piscina infantil coberta', value: 'Piscina infantil coberta'},
  {label: 'Piscina infantil descoberta', value: 'Piscina infantil descoberta'},
  {label: 'Piso elevado', value: 'Piso elevado'},
  {label: 'Pista de skate', value: 'Pista de skate'},
  {label: 'Playground', value: 'Playground'},
  {label: 'Pomar', value: 'Pomar'},
  {label: 'Port cochère', value: 'Port cochère'},
  {label: 'Portaria', value: 'Portaria'},
  {label: 'Praça', value: 'Praça'},
];

export const LETTER_Q: CheckboxListItem[] = [
  {label: 'Quadra', value: 'Quadra'},
  {label: 'Quadra de areia', value: 'Quadra de areia'},
  {label: 'Quadra de futebol society', value: 'Quadra de futebol society'},
  {label: 'Quadra de squash', value: 'Quadra de squash'},
  {label: 'Quadra de tênis', value: 'Quadra de tênis'},
  {label: 'Quadra de volei', value: 'Quadra de volei'},
  {label: 'Quadra gramada', value: 'Quadra gramada'},
  {label: 'Quadra poliesportiva', value: 'Quadra poliesportiva'},
  {label: 'Quintal', value: 'Quintal'},
];

export const LETTER_R: CheckboxListItem[] = [
  {label: 'Redário', value: 'Redário'},
  {label: 'Rede de água', value: 'Rede de água'},
  {label: 'Rede de energia elétrica', value: 'Rede de energia elétrica'},
  {label: 'Restaurante', value: 'Restaurante'},
  {label: 'Rua asfaltada', value: 'Rua asfaltada'},
];

export const LETTER_S: CheckboxListItem[] = [
  {label: 'Sala de artes marciais / luta', value: 'Sala de artes marciais / luta'},
  {label: 'Sala de cinema', value: 'Sala de cinema'},
  {label: 'Sala de convenção', value: 'Sala de convenção'},
  {label: 'Sala de leitura', value: 'Sala de leitura'},
  {label: 'Sala de massagem', value: 'Sala de massagem'},
  {label: 'Sala de música', value: 'Sala de música'},
  {label: 'Sala de reuniões', value: 'Sala de reuniões'},
  {label: 'Sala de spinning', value: 'Sala de spinning'},
  {label: 'Sala de yoga / pilates', value: 'Sala de yoga / pilates'},
  {label: 'Salão de beleza', value: 'Salão de beleza'},
  {label: 'Salão de festas', value: 'Salão de festas'},
  {label: 'Salão de festas adulto', value: 'Salão de festas adulto'},
  {label: 'Salão de festas infantil', value: 'Salão de festas infantil'},
  {label: 'Salão de jogos', value: 'Salão de jogos'},
  {label: 'Salão de jogos adulto', value: 'Salão de jogos adulto'},
  {label: 'Salão de jogos infantil', value: 'Salão de jogos infantil'},
  {label: 'Salão de jogos juvenil', value: 'Salão de jogos juvenil'},
  {label: 'Salão de recreação', value: 'Salão de recreação'},
  {label: 'Sauna', value: 'Sauna'},
  {label: 'Sede social', value: 'Sede social'},
  {label: 'Segurança', value: 'Segurança'},
  {label: 'Serviços', value: 'Serviços'},
  {label: 'Shaft de telecomunicações', value: 'Shaft de telecomunicações'},
  {label: 'Solarium', value: 'Solarium'},
  {label: 'Sótão', value: 'Sótão'},
  {label: 'Spa', value: 'Spa'},
  {label: 'Spiribol', value: 'Spiribol'},
  {label: 'Street ball', value: 'Street ball'},
];

export const LETTER_T: CheckboxListItem[] = [
  {label: 'Teatro', value: 'Teatro'},
  {label: 'Terraço', value: 'Terraço'},
  {label: 'Trilha / pista de caminhada', value: 'Trilha / pista de caminhada'},
  {label: 'Triplex', value: 'Triplex'},
];

export const LETTER_V: CheckboxListItem[] = [
  {label: 'Vaga de visitante', value: 'Vaga de visitante'},
  {label: 'Varanda gourmet', value: 'Varanda gourmet'},
  {label: 'Vestiário', value: 'Vestiário'},
  {label: 'Vestiário para funcionários', value: 'Vestiário para funcionários'},
  {label: 'Vila hípica', value: 'Vila hípica'},
];
